import React from "react";
import "./style.scss";

const QuestionWrapper = (props) => {
  return (
    <>
      <div className="question-wrapper">
        <span className="question-title">{props.title}</span>
        <div className="question-answer">{props.content}</div>
      </div>
      {props.noLine ? null : <hr />}
    </>
  );
};

export default QuestionWrapper;
